
import React from 'react'
import { connect } from 'react-redux'
import { Layout,Avatar, Menu, Breadcrumb,Button,Row, Col, Divider,Card,Dropdown,Switch,
    message, Tooltip,InputNumber,Table,Popover,Modal,Image,Form,Select,Spin,Input} from 'antd';
import { Drawer, List,Alert,Affix } from 'antd';

import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  TeamOutlined,
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LaptopOutlined,
  NotificationOutlined,
  SettingOutlined,
  AuditOutlined,
  IdcardOutlined,
  BarsOutlined,
  ShopOutlined,
  DollarOutlined,
  PicLeftOutlined,
  LogoutOutlined,
  EditOutlined, 
  EllipsisOutlined,
  HomeOutlined,
  SnippetsOutlined,
  KeyOutlined,
  FilePdfFilled,
  RightCircleFilled,
  DollarCircleOutlined,
  AccountBookOutlined,
  FilePptOutlined,
  PayCircleOutlined,
  BarChartOutlined,
  MinusSquareOutlined,
  PlusSquareOutlined,
  BankFilled,
  AndroidOutlined,
  DeploymentUnitOutlined,
  GroupOutlined,
  AccountBookFilled,
  CalculatorFilled,
  FileFilled,
  MessageFilled,
  LoadingOutlined,
  FundViewOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';
import { Badge, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem } from 'reactstrap';
import UIfx from 'uifx';

import { NavLink } from 'react-router-dom'
import { PageHeader, Descriptions } from 'antd';
import { Link,withRouter} from 'react-router-dom';
import * as actions from '../../store/actions/auth'
import axios from 'axios'
import UserAccountUpdateForm from '../components/UserAccountUpdateForm'
import WrappedPasswordResetForm from './PasswordResetForm'
import WrappedPasswordResetForcedForm from './PasswordResetForcedForm'

import * as serverconfig from '../serverconn'
import * as serversocketconfig from '../serversocketconfig'

import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
import ReconnectingWebSocket from 'reconnecting-websocket';
import tickAudio from '../../assets/sounds/that-was-quick.mp3';
import IdleTimer from 'react-idle-timer';

var CryptoJS = require("crypto-js");

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;
const style = { background: '#0092ff', padding: '8px 0' };
const { Meta } = Card;
const dateFormat = 'DD/MM/YYYY';
const FormItem=Form.Item;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;


const tick = new UIfx(tickAudio,  {
  volume: 1.0, // number between 0.0 ~ 1.0
  throttleMs: 100
});

const pStyle = {
  fontSize: 16,
  lineHeight: '24px',
  display: 'block',
  marginBottom: 16,
};



const DescriptionItem = ({ title, content }) => (
  <div
    className="site-description-item-profile-wrapper"
    style={{
      fontSize: 14,
      lineHeight: '22px',
      marginBottom: 7,
    }}
  >
    <p
      className="site-description-item-profile-p"
      style={{
        marginRight: 8,
        display: 'inline-block',
      }}
    >
      {title}:
    </p>
    {content}
  </div>
);

var bizuserid= ''
var sacco= ''
var token= ''


class SaccoLayout extends React.Component{

  state = {
    collapsed: false,
    theme: 'dark',
    current: '1',
    titlecolor: '#fff',
    titlevisibility:"visible",
    userprofile:{},
    companyprofile:{},
    appprofile:{},

    isToggle: null,
    visible: false,
    resetmodalvisible:false,
    updateformvisible:'none',
    userrights:{},
    date_today:moment().format(dateFormat).toString(),
    dashboardlocked:false,
    userbalancemodalvisible:false,
    users:[],
    userto:'',
    transferamount:0,
    datarequested:false,
    transfermode:'',
    safemanagertransfermode:'',
    numberofnotifications:0,
    notificationinfo:'',
    balanceacceptancemodalvisible:false,
    selectedtransferobject:{},
    acceptancestatus:'',

    isTimedOut: false,
    showtimeoutmodal:false,


    otp_modal_visible:false,
    otp_code:'',
    otp_sent:false,
    passwordchange_modal_visible:false,


  };

  // show the profile modal
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  // update user profile
  showUpdateForm=()=>{
    this.state.updateformvisible=="none"?
    this.setState({
      updateformvisible: "block",
    })
    :
    this.setState({
      updateformvisible: "none",
    })    
  }


  /////////////////////////////////////////////
  //PASSWORD RESET MODAL METHODS BEGIN HERE

  showpasswordresetModal = () => {
    this.setState({
      resetmodalvisible: true,
    });
  };

  //Item addition success
  onresetdrawerClose = () => {
    this.setState({ resetmodalvisible: false });

  };


  //show user balance modal
  showuserbalancemodalvisible=()=>{
    this.setState({ userbalancemodalvisible: true });
  }

  hideuserbalancemodalvisible=()=>{
    this.setState({ userbalancemodalvisible: false });
  }

  //show hide balance acceptance modal
  openbalanceacceptancemodalmodal=(record)=>{
    this.setState({ acceptancestatus: ''})
    //console.log(record)
    this.setState({balanceacceptancemodalvisible: true });
    this.setState({selectedtransferobject:record})

  }

  closebalanceacceptancemodalmodal=()=>{
    this.setState({balanceacceptancemodalvisible: false });

  }



//component did mount
  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
        bizuserid= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    //component mount method
    this.componentmountmethod();
    
  }

//component mount method
componentmountmethod=()=>{


  axios.get(serverconfig.backendserverurl+`/api/accounts/${bizuserid}`)
  .then(res => {
      this.setState({
        userprofile:res.data
      })


      //check if otp veirfy
      if (res.data.login_verified===true){
        this.setState({otp_modal_visible:false})
      }else{
        this.setState({otp_modal_visible:true})
      }

      //password change by force
      if(res.data.change_password===true){
        this.setState({passwordchange_modal_visible:true})
      }


  })


  axios.get(serverconfig.backendserverurl+`/api/saccos/${sacco}`)
  .then(res => {
      this.setState({
        companyprofile:res.data
      })

      if (res.data.activated===false){
        this.setState({dashboardlocked:true})
      }
  })

  axios.get(serverconfig.backendserverurl+`/api/companyprofile/${1}`)
  .then(res => {
      this.setState({
        appprofile:res.data
      })
  })


  axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
  .then(res => {
      this.setState({
        userrights:res.data[0]
      })
  })

  axios.get(serverconfig.backendserverurl+`/api/accounts/?sacco=${sacco}`)
  .then(res => {
      this.setState({
        users:res.data
      })
    })

}

  //method for changing color theme 
  changeTheme = value => {
    this.setState({
      theme: value ? 'dark' : 'light',
    });

    this.setState({
      titlecolor: value ? '#fff' : '#A9A9A9',
    });
    

  };

  //method for collupsing of the menu
  onCollapse = collapsed => {
    console.log(collapsed);
    this.setState({ collapsed });
    this.setState({titlevisibility: collapsed ? "hidden" :"visible"});
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });

    this.setState({titlevisibility:"hidden"});

  };


  handleusertoChange= (e) => this.setState({ userto: e});
  handletransferamountChange= (e) => this.setState({ transferamount: e});
  handletransfermodeChange= (e) => this.setState({ transfermode: e});
  handlesafemanagertransfermodeChange= (e) => this.setState({ safemanagertransfermode: e});
  handleacceptancestatusChange= (e) => this.setState({ acceptancestatus: e});


  //submit the deposit now
  handleFormSubmit=(event) =>{
    if (this.state.userto===''){
      message.info("User To cant be empty")
    }else if(Number(this.state.transferamount)>Number(this.state.userprofile.User_balance)){
      message.info("Transfer Amount cant be greater than available user balance")
    }else if(Number(this.state.userto)===Number(bizuserid)){
      message.info("You cant transfer to own account")
    }
    else{
      this.setState({datarequested:true})
  
      let form_data = new FormData();
      form_data.append('date',moment().format(dateFormat).toString());
      form_data.append('userfrom', bizuserid);
      form_data.append('userto', this.state.userto);
      form_data.append('transferAmount', this.state.transferamount);
      form_data.append('status', "pending");
      form_data.append('sacco', sacco);

      axios.post(serverconfig.backendserverurl+'/customqueries/userbalancetransfer', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
      .then(res => {
        this.setState({datarequested:false})
        message.info(res.data.message)
        window.location.reload(false)

      })
      .catch(error => console.log(error))
    }
    

  }

  handlemanagerTransferSubmit=(event) =>{
    if (this.state.safemanagertransfermode===''){
      message.info("Safe Manager Transfer Mode cant be empty")
    }else if(this.state.safemanagertransfermode==="manager_safe" &&  Number(this.state.transferamount)>Number(this.state.userprofile.User_balance)){
      message.info("Transfer Amount cant be greater than available user balance")
    }else if(this.state.safemanagertransfermode==="safe_manager" &&  Number(this.state.transferamount)>Number(this.state.companyprofile.safe_balance)){
      message.info("Transfer Amount cant be greater than available safe balance")
    }
    else{
      this.setState({datarequested:true})
  
      let form_data = new FormData();
      form_data.append('date',moment().format(dateFormat).toString());
      form_data.append('userid', bizuserid);
      form_data.append('transferAmount', this.state.transferamount);
      form_data.append('sacco', sacco);
      form_data.append('safemanagertransfermode', this.state.safemanagertransfermode);

      axios.post(serverconfig.backendserverurl+'/customqueries/managersafetransfer', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
      .then(res => {
        this.setState({datarequested:false})
        message.info(res.data.feedback.message)
        window.location.reload(false)
      })
      .catch(error => console.log(error))
    }

  }



   render(){

    return (
      <div>

      <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onActive={()=>{}}
            onIdle={()=>{
              this.props.logout()

/*           console.log("AM IDLE")

              const isTimedOut = this.state.isTimedOut

              if (isTimedOut) {
              } else {
                  this.setState({showtimeoutmodal: true})
                  this.idleTimer.reset();
                  this.setState({isTimedOut: true})
                }*/

            }}
            onAction={()=>{}}
            debounce={250}
            timeout={this.state.appprofile.sessiontimeoutmilliseconds} />


        {
         this.props.isAuthenticated  && this.state.otp_modal_visible===false?
         <Layout style={{ minHeight: '100vh' }} >
           {
             this.state.dashboardlocked===false?
             <Sider
             collapsedWidth="0"
             collapsed={this.state.collapsed}
             onCollapse={this.onCollapse} 
             theme={this.state.theme}
             breakpoint="lg"
             onBreakpoint={broken => {
               console.log(broken);
             }}
             zeroWidthTriggerStyle={{display:'none'}}
             style={{width:400}}
             >
               <br></br>
              <div className="logo" style={{ paddingLeft: 30}} mode="inline">
              <Row>
   
                <Col span={6}>
   {/*               <Avatar size={40} icon={<UserOutlined />} alt="Logo" src={this.state.companyprofile.company_logo} />
           */}               
                <Image
                 width={50}
                 height={50}
                 src={this.state.companyprofile.sacco_logo}   
                 preview={false} 
                 />
                <h6 style={{display:'flex',color:'white',margin:3}}>{this.state.companyprofile.sacco_name}</h6> 

                </Col>
   {/*             <Col span={18}><NavLink to='/'><h5 style={{color:this.state.titlecolor,paddingTop: 10,visibility:this.state.collapsed?"hidden":"visible" }}>{this.state.companyprofile.company_name}</h5></NavLink></Col>
         */}           </Row>
              <br/>
              </div>
   
              <Menu 
              theme={this.state.theme}
              onClick={this.handleClick}
              defaultSelectedKeys={['1']} 
              mode="vertical">
   
               <SubMenu
                  key="sub1"
                  title={
                    <span>
                      <HomeOutlined />
                      <span>Home</span>
                    </span>
                  }
                >
               <Menu.Item key="0" >
                 <RightCircleFilled />
                 <NavLink to='/'><span>Home</span></NavLink>
               </Menu.Item>

               </SubMenu>
               </Menu>

            </Sider>
             :
             null
           }
           
        
         <Layout className="site-layout">
   
            <PageHeader
              style={{backgroundColor: "white"}}
              ghost={true}
              tags={React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {className: 'trigger',
              onClick: this.toggle,
            })}
              extra={[
                <Badge  onClick={()=>{this.showuserbalancemodalvisible()}}  pill color="danger">{this.state.numberofnotifications}</Badge>,
                <Avatar size={30} icon={<UserOutlined />} alt="User Pic" src={serverconfig.backendserverurl+this.state.userprofile.profile_pic} />,
                <Dropdown.Button overlay={(    <Menu >
                  <Menu.Item key="1" onClick={this.props.logout}>
                    <LogoutOutlined />
                    Log out
                  </Menu.Item>
                  <Menu.Item key="2" onClick={this.showDrawer}>
                    <UserOutlined />
                    View Profile
                  </Menu.Item>
                  <Menu.Item key="3" onClick={this.showpasswordresetModal}>
                    <KeyOutlined />
                    Change Password
                  </Menu.Item>
                  {
                    this.state.companyprofile.userbalancesfeature?
                    <Menu.Item key="4" onClick={this.showuserbalancemodalvisible}>
                    <DollarCircleOutlined />
                    User Balance
                    </Menu.Item>        
                    :
                    null
                  }
            
                </Menu>)}>
                Hi, {this.state.userprofile.username}
                </Dropdown.Button>
              ]}
              >
          </PageHeader>
        


           <Content style={{ margin: '0 16px' }}>
             <br></br>
             {
               this.state.notificationinfo===""?
               null
               :
               <NavLink >
                <Alert showIcon message={this.state.notificationinfo} type="info" onClick={()=>{this.showuserbalancemodalvisible()}} />
               </NavLink>


             }

             <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
          
             <br></br>
            <div style={{display:'flex',flexDirection:'row'}}>
            
            {
            this.props.location.pathname==='/'?
            null:
            <Affix>

            <Tooltip title="Go to home">
            <HomeOutlined style={{display:'flex',fontSize: 30,marginRight:30}} onClick={()=>{
              this.props.history.push('/')      
              }}/>
            </Tooltip>
            </Affix>
              }


              {
                this.props.location.pathname==='/'?
                null:
                <Affix>
                <Tooltip title="Go back">
                <ArrowLeftOutlined style={{display:'flex',fontSize: 30,marginRight:5}} onClick={()=>{
                  this.props.history.goBack()      
                  }}/>
                </Tooltip>
                </Affix>
              }

            </div>
            <br></br>
          
          
             {this.props.children}
             </div>
           </Content>
           <Footer style={{ textAlign: 'center' }}>System Design © 2021 Created by PI-Tech</Footer>
         </Layout>
       </Layout>
         :
         <Layout style={{ minHeight: '100vh' }}>
         <Content className="site-layout" style={{ padding: '0 50px', marginTop: 64 }}>
           <div className="site-layout-background" style={{padding: 24, minHeight: 380,display: 'flex',  justifyContent:'center', alignItems:'center' }}>
             {this.props.children}
           </div>
         </Content>
         <Footer style={{ textAlign: 'center' }}>System Design © 2021 Created by PI-Tech</Footer>
         </Layout>
        }

        <Drawer
          title="Account Profile"
          width={520}
          placement="right"
          closable={false}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          <p style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>      
             <Avatar
              size={100}
              icon={<UserOutlined />}
              alt="client logo"
              src={serverconfig.backendserverurl+this.state.userprofile.profile_pic}
              />
          </p>
          <Row>
            <Col span={12}>
              <DescriptionItem title="User Name" content={this.state.userprofile.username} />
            </Col>
            <Col span={12}>
              <DescriptionItem title="Email" content={this.state.userprofile.email} />
            </Col>
          </Row>         
          <p style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>      
             <Button type="primary" onClick={this.showUpdateForm}>
               {
                 this.state.updateformvisible=="none"?
                 "Open Update Form"
                 :
                 "Close Update Form"
               }
               
               </Button>
          </p>
          
          <div style={{display:this.state.updateformvisible}}>
           <UserAccountUpdateForm accountID={this.state.userprofile.id} username={this.state.userprofile.username} email={this.state.userprofile.email}/>       

          </div>

        </Drawer>


        <Drawer
          title="Password Change Form"
          width={520}
          placement="right"
          closable={false}
          onClose={this.onresetdrawerClose}
          visible={this.state.resetmodalvisible}
        >
            <WrappedPasswordResetForm />

        </Drawer>
     

        <Modal              
          visible={this.state.showtimeoutmodal}
          title={<h3>You Have Been Idle!</h3>}
          width={600}
          onCancel={()=>{
            this.setState({showtimeoutmodal:false})
          }}
      
          footer={[
            <Button key="back" type='default' onClick={()=>{
              this.props.logout()
            }}>
              Logout
            </Button>,

            <Button type='primary' key="back" onClick={()=>{this.setState({showtimeoutmodal:false})}}>
            Stay
            </Button>

            ]}
            >
              
              <h5>You Will Get Timed Out. You want to stay?</h5>
                   
      </Modal>


      <Modal   
          visible={this.state.otp_modal_visible}
          title="Otp verification form"
      
          footer={[
          
            ]}
            >
              <h4 style={{color:'green'}}>Enter verification otp code sent to your email here.</h4>
              <h5 style={{color:'orange',display:'flex',alignContent:'center',alignItems:'center',alignSelf:'center'}}> Code expires in 120 seconds (2 minutes)</h5>
            <br></br>
            <br></br>

            {
              this.state.otp_sent===true?
              <Spin tip="Loading" size="large">
                <div className="content" />
              </Spin>
              :

            <div>

            <FormItem label="Otp code">

            <Input name="otp_code" type='number' placeholder="Otp code" value={this.state.otp_code} onChange={(val)=>{this.setState({otp_code:val.target.value})}} />
            </FormItem>

            <div style={{display:'flex',flexDirection:'row'}}>

            <FormItem style={{margin:10}} >
            <Button type='primary' onClick={()=>{

              if(this.state.otp_code.length<4 || this.state.otp_code.length>4 ){
                message.error("Otp code is exactly 6 digits")
              }else{
                this.setState({otp_sent:true})
                let form_data = new FormData();
                form_data.append('user_id', bizuserid);
                form_data.append('otp_code', this.state.otp_code);
                axios.post(serverconfig.backendserverurl+'/customqueries/verify_otp', form_data, {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                  })
                .then(res => {
                  this.setState({otp_sent:false})
                  message.info(res.data.message)

                  if(res.data.message==="Verified"){
                    window.location.reload(false)
                  }

                })
                .catch(error => console.log(error))
              }

            }}>Verify otp</Button>
            </FormItem>

            <FormItem style={{margin:10}}
            
            onClick={()=>{
          
                this.setState({otp_sent:true})
                let form_data = new FormData();
                form_data.append('user_id', bizuserid);
                axios.post(serverconfig.backendserverurl+'/customqueries/re_request_otp', form_data, {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                  })
                .then(res => {
                  this.setState({otp_sent:false})
                  message.info(res.data.message)

                })
                .catch(error => console.log(error))
              
            }}
            
            >
            <Button type='primary'>Request new otp code</Button>
            </FormItem>

            </div>
            </div>           
             }

        </Modal> 



        <Modal   
          visible={this.state.passwordchange_modal_visible}
          title="Password update form"
      
          footer={[
          
            ]}
            >
              <h4 style={{color:'red'}}>Please update your password before you proceed any further</h4>
              <WrappedPasswordResetForcedForm />

        </Modal>  


      </div>
  );

  }

}


const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(
      actions.logout(),
      )
  }
}


export default withRouter(connect(null,mapDispatchToProps)(SaccoLayout)) ;

  
